import script from "./AddCsvRecipes.vue?vue&type=script&setup=true&lang=js"
export * from "./AddCsvRecipes.vue?vue&type=script&setup=true&lang=js"

import "./AddCsvRecipes.vue?vue&type=style&index=0&id=8ae33296&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8ae33296"]])

export default __exports__